<div class="enter-amount d-flex flex-column justify-content-between">
    <div class="p2p-header p-4">
        <div class="d-flex justify-content-start align-items-center cursor-pointer" (click)="cancel()">
            <mat-icon fontIcon="arrow_back"></mat-icon>
            <span>Back</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center my-4">
            <div class="icon">
                <mat-icon svgIcon="wallet-money"></mat-icon>
            </div>
            <h2>Peer to Peer Money</h2>
        </div>
    </div>

    <div class="receiver-details-box p-2 mx-4">
        <div class="receiver-details-title">Receiver Details</div>
        <div class="d-flex flex-column justify-content-center align-items-center my-2">
            <p class="receiver-name">{{ maskedRecipientName }}</p>
            <p class="receiver-phone">{{ formattedRecipientMobile }}</p>
        </div>
    </div>

    <div class="wallet-container px-4 mt-4">
        <div class="wallet-section-box">
            <div class="wallet-header d-flex justify-content-between align-items-center">
                <div class="wallet-title">Sender's Wallet</div>
                <div class="wallet-balance">Balance: {{ availableBalance | number : balanceDecimals }}</div>
            </div>
            <div class="wallet-input-group">
                <div class="currency-select">
                    <img [src]="'/assets/currency-flags/' + selectedCurrency + '-flag.svg'" [alt]="selectedCurrency" class="currency-flag me-1" />
                    <select class="currency-native-select" [value]="selectedCurrency" (change)="onCurrencyChange($event)">
                        <option *ngFor="let currency of currencies" [value]="currency">{{ currency }}</option>
                    </select>
                </div>
                <input type="number" class="form-control amount-input" placeholder="Enter Amount" [formControl]="amountControl" />
            </div>
        </div>
        <div *ngIf="isInsufficientBalance" class="error-message" style="font-size: 13px">Insufficient balance. The entered amount exceeds your available balance.</div>
        <div *ngIf="amountControl.hasError('required') && amountControl.touched" class="error-message" style="font-size: 13px">Amount is required.</div>
        <div *ngIf="amountControl.hasError('min') && amountControl.touched" class="error-message" style="font-size: 13px">
            Minimum top-up amount is {{ minimumAmount | number : balanceDecimals }} {{ selectedCurrency }}.
        </div>
    </div>

    <textarea class="m-4 my-2 form-control w-auto" placeholder="Add a note (Optional)" [formControl]="noteControl"></textarea>

    <div class="footer d-flex justify-content-start align-items-center p-4 w-100">
        <button
            mat-raised-button
            class="btn-primary rounded-pill me-2"
            [class.btn-primary-disabled]="amountControl.invalid || isInsufficientBalance"
            [disabled]="amountControl.invalid || isInsufficientBalance"
            (click)="confirm()"
        >
            Confirm
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="cancel()">Cancel</button>
    </div>
</div>
